import { render, staticRenderFns } from "./_disclaimer.vue?vue&type=template&id=03a4b791&scoped=true"
import script from "./_disclaimer.vue?vue&type=script&lang=js"
export * from "./_disclaimer.vue?vue&type=script&lang=js"
import style0 from "./_disclaimer.vue?vue&type=style&index=0&id=03a4b791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4b791",
  null
  
)

export default component.exports